module.exports = __webpack_public_path__ + "img/icon12.8aaa83ce.png";